import React, {useState, useEffect} from "react";
import {Link} from 'react-router-dom'
import { findObjectByKeyValue } from '../utils.js';
import { Spinner } from "../common/Spinner";
import { ErrorMessage } from "../common/ErrorMessage";
import PlayerListItem from './PlayerListItem';
import TutorialTooltip from '../common/TutorialTooltip';

import playerIco from "../../../src/assets/player.svg"

function ListPlayers({
  props, 
  playersOnField, 
  playerIdsOnBench, 
  removePlayer, 
  touchPlayer, 
  touchedPlayer, 
  isLoading, 
  error, 
  leagueSlug
}) {
    // Handle loading state
    if (isLoading) {
        return (
            <div className="players-list-container loading-container">
                <Spinner />
                <p>Loading players...</p>
            </div>
        );
    }

    // Handle error state
    if (error) {
        return (
            <div className="players-list-container">
                <ErrorMessage message="Error loading players" error={error} />
            </div>
        );
    }

    // Handle empty state
    if (!props || props.length === 0) {
        return (
            <div className="players-list-container empty-state">
                <h3>No players found for this team</h3>
                <p>This team doesn't have any players yet.</p>
                <Link to={`/${leagueSlug}/transfers-players`} className="settings-submit-btn">
                    GO TO TRANSFERS
                </Link>
            </div>
        );
    }

    let roleGroups = [
        {
            title: "forwards",
            players: []
        },
        {
            title: "midfielders",
            players: []
        },
        {
            title: "defenders",
            players: []
        },
        {
            title: "goalkeepers",
            players: []
        }
    ]

    // Process the API data structure
    props.forEach(function (player, index) {
        // Map player position to role
        let role = "midfielders"; // default role
        
        // *** UPDATED LOGIC: Determine role based on player.role.name ***
        if (player && player.role && player.role.name) {
            const roleName = player.role.name.toLowerCase();
            if (roleName.includes('goalkeeper')) {
                role = "goalkeepers";
            } else if (roleName.includes('defender')) {
                role = "defenders";
            } else if (roleName.includes('midfielder')) {
                role = "midfielders";
            } else if (roleName.includes('forward')) {
                role = "forwards";
            }
        } else {
            // *** DEBUG LOGGING START ***
            console.warn(`[ListPlayers] Player ${player?.name} (wyId: ${player?.wyId}) missing role.name, defaulting role to midfielders. Role data:`, player?.role);
            // *** DEBUG LOGGING END ***
        }
        
        // Ensure player has a role property for compatibility
        const processedPlayer = {
            ...player,
            // Use the determined role string for grouping, keep original role object too
            roleGroup: role, 
            id: player._id || player.id, // Ensure id is available
            name: player.name,
            number: player.number || index + 1,
            position: player.position || 'N/A',
            img: player.img || player.photo || playerIco
        };
        
        // Assign player to the correct group based on the determined roleGroup string
        const targetGroup = findObjectByKeyValue(roleGroups, 'title', processedPlayer.roleGroup);
        if (targetGroup) {
            targetGroup.players.push(processedPlayer);
        } else {
            // Fallback if something went wrong
            findObjectByKeyValue(roleGroups, 'title', 'midfielders').players.push(processedPlayer);
        }
    })

    const CountAlert = () => {

        return (
            <div className="count-alert">
                <div className="tip">
                    Your squad must have a minimum of 22 players
                </div>

                <Link to={`/${leagueSlug}/transfers-players`} className="settings-submit-btn">
                    TO TRANSFERS
                </Link>

            </div>
        )
    }

    // console.log(roleGroups);

    return (
      <div className="players-list">
          <div className="players-list-frame-container">
              <div className="frame">
                  {roleGroups.map((group, index) => (
                      <div key={index} className="type-block">
                          <h4>
                              {group.title} ({group.players.length})
                          </h4>

                          <div className="p-t-list">
                              {group.players.map(player => (
                                <PlayerListItem
                                  key={player.id || player.wyId}
                                  player={player}
                                  playersOnField={playersOnField}
                                  playerIdsOnBench={playerIdsOnBench}
                                  removePlayer={removePlayer}
                                  touchPlayer={touchPlayer}
                                  touchedPlayer={touchedPlayer}
                                />
                              ))}
                          </div>
                      </div>

                  ))}
              </div>

              { props.length < 22 ? CountAlert() : ''}

          </div>


      </div>
  )
}

export {ListPlayers}
